import { render, staticRenderFns } from "./Salary.vue?vue&type=template&id=1e9a1edc&"
import script from "./Salary.vue?vue&type=script&lang=js&"
export * from "./Salary.vue?vue&type=script&lang=js&"
import style0 from "./Salary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports